<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Half-title02">
<p class="half"><span epub:type="pagebreak" id="page_ix" title="ix"><span epub:type="pagebreak" id="page_x" title="x">THREE MIDWESTERN PLAYWRIGHTS</span></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Half-title02.vue?2cfde455